import React from "react";
import { ShareEmailEntry, TeamEmailEntry } from "./entities";
import { EmailItem } from "./EmailItem";
import { ResourceType } from "./entities";
import { Button } from "components/common/Button";
interface EmailListProps {
  items: (ShareEmailEntry | TeamEmailEntry)[];
  isShareMode: boolean;
  isTeamMode: boolean;
  currentUserEmail?: string;
  isCreatingTeam?: boolean;
  resourceType?: ResourceType;
  disabled?: boolean;
  updateEmailSettings?: (
    email: string,
    field: string,
    value: string | number,
  ) => void;
  onShare?: () => void;
  onShareCancel?: () => void;
  onAccessLevelChange?: (email: string, accessLevel: string) => void;
  onRemove?: (email: string) => void;
  onTeamAdd?: () => void;
  onTeamCancel?: () => void;
  canRevokeAccess: boolean;
}

export const EmailList: React.FC<EmailListProps> = (props) => {
  if (props.items.length === 0 && !props.isTeamMode) return null;

  const hasMembers = props.items.length > 0;

  const renderActionButtons = (
    onAction: () => void,
    onCancel: () => void,
    actionLabel: string,
    actionDisabled: boolean,
    cancelDisabled: boolean = false,
  ) => (
    <div className="flex items-center gap-2 w-full">
      <Button
        type="button"
        variant="secondary"
        onClick={onCancel}
        disabled={cancelDisabled}
        className="flex-1"
      >
        Cancel
      </Button>
      <Button
        onClick={onAction}
        disabled={actionDisabled}
        variant="primary"
        className="flex-1"
      >
        {actionLabel}
      </Button>
    </div>
  );

  return (
    <div className="mb-2 space-y-2 overflow-visible">
      {props.isTeamMode &&
        !hasMembers &&
        props.onTeamAdd &&
        props.onTeamCancel &&
        renderActionButtons(
          props.onTeamAdd,
          props.onTeamCancel,
          "Add",
          props.disabled || !hasMembers,
          props.disabled,
        )}

      {props.items.map((item, index) => {
        const isCurrentUser =
          props.isTeamMode &&
          props.isCreatingTeam &&
          item.email === props.currentUserEmail;

        return (
          <EmailItem
            key={index}
            item={item}
            index={index}
            isShareMode={props.isShareMode}
            isCurrentUser={isCurrentUser}
            resourceType={props.resourceType}
            updateEmailSettings={props.updateEmailSettings}
            onAccessLevelChange={props.onAccessLevelChange}
            onRemove={props.onRemove}
            disabled={props.disabled}
            canRevokeAccess={props.canRevokeAccess}
          />
        );
      })}

      {props.isShareMode &&
        props.onShare &&
        props.onShareCancel &&
        renderActionButtons(
          props.onShare,
          props.onShareCancel,
          "Share",
          props.items.length === 0,
          false,
        )}

      {props.isTeamMode &&
        hasMembers &&
        props.onTeamAdd &&
        props.onTeamCancel &&
        renderActionButtons(
          props.onTeamAdd,
          props.onTeamCancel,
          "Add",
          props.disabled || !hasMembers,
          props.disabled,
        )}
    </div>
  );
};
